module.exports = __webpack_public_path__ + "img/Group 17.c908daa4.svg";